module.exports = __webpack_public_path__ + "static/media/money.6ec750de.gif";